import { useState, useEffect, useCallback } from "react"

import {
	Box,
    Divider,
	IconButton,
	Paper,
	Popover,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Alert,
    AlertTitle
} from "@mui/material"

import LoadingButton from "@mui/lab/LoadingButton"

import FilterIcon from "@mui/icons-material/FilterAlt"
import UpdateIcon from "@mui/icons-material/Update"

import useNotification from "../../../Notification"
import Templates from "../../../Crm/Templates"
import api from "../../../../api"
import { getSession } from "../../../../auth"

export default function FinishedFilter({ classificationFilter, setClassificationFilter, selectedChats, setSelectedChats }) {
	const [ showPopover, setShowPopover ] = useState(false)
    const [ anchorEl, setAnchorEl ] = useState(null)
    const [ showReactivationDialog, setShowReactivationDialog ] = useState(false)
    const [ withTemplates, setWithTemplates ] = useState(false)
    const [ reactivationMessage, setReactivationMessage ] = useState("")
    const [ loading, setLoading ] = useState(false)

    const reactivateChats = useCallback(async (message, template, parameters, mediaParameters) => {
        setLoading(true)
        await Promise.all(selectedChats.filter(chat => chat.platform === "WHATSAPP").map((chat) => {
            if (withTemplates) {
                if (parameters.length !== 0) {
                    const formdata = new FormData()
                    if ("headerfile" in mediaParameters)
                        formdata.append("headerfile", mediaParameters.headerfile)
                    if ("headerbody" in mediaParameters)
                        formdata.append("headerbody", mediaParameters.headerbody)
                    if ("body" in mediaParameters)
                        Object.values(mediaParameters.body).map(p => formdata.append("body", p))
                    if ("buttons" in mediaParameters)
                        formdata.append("buttons", mediaParameters.buttons)
                    formdata.append("from", chat.sender)
                    formdata.append("to", chat.callerid)
                    formdata.append("queue_name", chat.queue?.name?.split("_").pop())
                    formdata.append("template", template.name)
                    formdata.append("chat_id", chat.id)
                    formdata.append("agent", getSession().profile.agent.user.split("_").pop())
                    formdata.append("reactivation", true)
                    return api.post("api/whatsapp/medianotification/", formdata)
                }
                return api.post("api/whatsapp/reactivation/", {
                    "from": chat.sender,
                    "to": chat.callerid,
                    "chat_id": chat.id,
                    "queue_name": chat.queue?.name?.split("_").pop(),
                    "agent": getSession().profile.agent.user.split("_").pop(),
                    "template": template.name,
                    "parameters": parameters
                })
            }
            return api.post("api/whatsapp/reactivation/", {
                "from": chat.sender,
                "to": chat.callerid,
                "chat_id": chat.id,
                "queue_name": chat.queue?.name?.split("_").pop(),
                "agent": getSession().profile.agent.user.split("_").pop(),
                "message": message
            })
        }))
        setLoading(false)
        useNotification("Sucesso", "Chats reativados com sucesso.", "success")
        setShowReactivationDialog(false)
        setReactivationMessage("")
        setSelectedChats([])
    }, [selectedChats, withTemplates])

    useEffect(() => {
        if (showReactivationDialog)
            setWithTemplates(selectedChats.some((chat) => {
                if (! chat.last_user_msg_time)
                    return false
                const lastMsgTime = new Date(chat.last_user_msg_time * 1000)
                const now = new Date()
                const diffHours = (now - lastMsgTime) / (1000 * 60 * 60)
                return diffHours >= 24
            }))
    }, [showReactivationDialog])

	return (
        <Box className="filter-chats finished-chats-filter">
            <Paper component="form" sx={{ display: "flex", alignItems: "center", height: 50, bgcolor: "#efefef", justifyContent: "end" }}>
                <Tooltip title="Reativar atendimentos selecionados" placement="bottom" disableInteractive>
                    <IconButton sx={{ mr: ".25rem" }}
                        color="primary"
                        aria-label="directions"
                        onClick={() => setShowReactivationDialog(true)}
                        className="filter-icon"
                    >
                       <UpdateIcon />
                    </IconButton>
                </Tooltip>
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <Tooltip title="Filtros" placement="bottom" disableInteractive>
                    <IconButton sx={{ mr: ".25rem" }}
                        color="primary" 
                        aria-label="directions"
                        onClick={(event) => {
                        	setShowPopover(true)
                        	setAnchorEl(event.currentTarget)
                        }}
                        className="filter-icon"
                    >
                       <FilterIcon />
                    </IconButton>
                </Tooltip>
                <Popover
                    className="popover-filter"
                    open={showPopover}
                    anchorEl={anchorEl}
                    onClose={() => {
                    	setShowPopover(false)
                    	setAnchorEl(null)
                    }}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                	<ToggleButtonGroup
		                value={classificationFilter}
		                exclusive
		                onChange={(_, newValue) => setClassificationFilter(newValue)}
		                orientation="vertical"
		                sx={{ display: "flex", width: "100%" }}
		            >
		                <ToggleButton value="forahora">Fora do Horário de Atendimento</ToggleButton>
		                <ToggleButton value="timeout">Desligadas por Timeout</ToggleButton>
		            </ToggleButtonGroup>
                </Popover>
            </Paper>
            {showReactivationDialog && withTemplates &&
                <Templates
                    title="Reativar Chats Selecionados"
                    open={showReactivationDialog}
                    reactivationSenders={selectedChats.map((chat) => chat.sender)}
                    originNumbers={[]}
                    hideNumbers={true}
                    queues={[]}
                    hideQueues={true}
                    templates={[]}
                    selectionIds={[0]} // adding one element to now break forward
                    handleClose={() => setShowReactivationDialog(false)}
                    handleSubmit={(template, parameters, mediaParameters) =>
                        reactivateChats(undefined, template, parameters, mediaParameters)
                    }
                />
            }
            {showReactivationDialog && ! withTemplates &&
                <Dialog open={showReactivationDialog} onClose={() => setShowReactivationDialog(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Reativar Chats Selecionados</DialogTitle>
                    <Divider />
                    <DialogContent>
                        {selectedChats.length === 0
                            ? <Alert severity="warning" sx={{ mb: 2 }}>
                                <AlertTitle>Nenhum chat selecionado!</AlertTitle>
                                Selecione segurando a tecla CTRL e clicando nos chats que deseja reativar.
                            </Alert>
                            : <>
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    Escreva abaixo a mensagem que deseja enviar aos contatos.
                                </Alert>
                                <TextField
                                    label="Mensagem"
                                    multiline
                                    rows={4}
                                    fullWidth
                                    value={reactivationMessage}
                                    onChange={(event) => setReactivationMessage(event.target.value)}
                                    variant="outlined"
                                />
                            </>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Box display="flex" gap={1} pr={2} pb={1}>
                            <Button onClick={() => setShowReactivationDialog(false)}>
                                Cancelar
                            </Button>
                            <LoadingButton
                                onClick={() => reactivateChats(reactivationMessage)}
                                variant="contained"
                                color="primary"
                                disabled={selectedChats.length === 0 || ! reactivationMessage}
                                loading={loading}
                            >
                                Reativar
                            </LoadingButton>
                        </Box>
                    </DialogActions>
                </Dialog>
            }
        </Box>
	)	
}
